import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'stage-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stage-table.component.html',
  styleUrl: './stage-table.component.scss',
})
export class StageTableComponent<T extends { ok: boolean }> {
  @Input()
  displayColumns: (keyof T)[] = [];

  @Input()
  stagedReceipts: T[] = [];

  constructor() {}

  toUpperCase(col: keyof T): string {
    return (col as string).toUpperCase();
  }
}
